import { ReactElement } from 'react';

export const ProductGallerySkeleton = (): ReactElement => (
  <div className='cds-Skeleton-Wrapper--Pulse'>
    <div className='cds-Skeleton--Thumb' />
  </div>
);
